<header class="admin-header ynex-header">
  <div class="header-left">
    <button type="button" class="header-btn menu-toggle" (click)="onToggleSidebar()" aria-label="Menu">
      <span class="menu-toggle-icon" [class.is-open]="isMenuOpen">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </span>
    </button>
    <span class="header-title">PKG Super Admin</span>
  </div>

  <div class="header-right">
    <!-- Appels à passer (02/11/2026) : visibles de partout, clients en rouge. -->
    @if (callbacksCount > 0 || callbacksOpen) {
      <div class="header-notif-wrap header-calls-wrap">
        <button
          type="button"
          class="header-btn icon-btn notifications-btn calls-btn"
          [class.active]="callbacksOpen"
          [class.calls-btn--client]="clientCallbacks > 0"
          [title]="callsTitle"
          [attr.aria-label]="callsTitle"
          (click)="toggleCallbacks()">
          <i name="phone" [size]="18" [color]="clientCallbacks > 0 ? '#dc2626' : 'var(--text-color)'" Icons></i>
          <span class="notification-badge calls-badge" [class.calls-badge--client]="clientCallbacks > 0">{{ callbacksCount > 9 ? '9+' : callbacksCount }}</span>
        </button>
        @if (callbacksOpen) {
          <div class="notif-dropdown" (click)="$event.stopPropagation()">
            <div class="notif-dropdown__head">
              <strong>À appeler</strong>
              @if (clientCallbacks > 0) { <span class="calls-head-clients">{{ clientCallbacks }} client{{ clientCallbacks > 1 ? 's' : '' }}</span> }
            </div>
            <div class="notif-dropdown__body calls-body">
              <app-upcoming-callbacks [limit]="6" [reloadKey]="callbacksReload" (navigate)="callbacksOpen = false" />
            </div>
          </div>
        }
      </div>
    }
    <div class="header-notif-wrap">
      <button
        type="button"
        class="header-btn icon-btn notifications-btn"
        [class.active]="notificationsOpen"
        title="Actions urgentes"
        aria-label="Actions urgentes"
        (click)="toggleNotifications()">
        <i name="sms" [size]="20" [color]="'var(--text-color)'" Icons></i>
        @if (notificationCount > 0) {
          <span class="notification-badge">{{ notificationCount > 9 ? '9+' : notificationCount }}</span>
        }
      </button>
      @if (notificationsOpen) {
        <div class="notif-dropdown" (click)="$event.stopPropagation()">
          <div class="notif-dropdown__head">
            <strong>À traiter</strong>
            <button type="button" class="notif-link" (click)="goToActionCenter()">Tout voir</button>
          </div>
          <div class="notif-dropdown__body">
            <app-admin-action-list [items]="actionItems" [compact]="true" emptyMessage="Rien en attente." />
          </div>
        </div>
      }
    </div>
    <button type="button" class="header-btn icon-btn theme-toggle" (click)="toggleTheme()" [attr.title]="isDark ? 'Mode clair' : 'Mode sombre'" [attr.aria-label]="isDark ? 'Mode clair' : 'Mode sombre'">
      <i [name]="isDark ? 'sun' : 'moon'" [size]="18" [color]="isDark ? 'var(--yellow-color)' : 'var(--main-blue-medium-color)' " Icons></i>
    </button>

    <div class="header-avatar-wrap" #avatarWrap>
      <button
        type="button"
        class="avatar-trigger"
        (click)="toggleUserMenu()"
        [class.open]="userMenuOpen"
        [attr.aria-expanded]="userMenuOpen"
        aria-label="Menu utilisateur">
        <span class="avatar-initials" aria-hidden="true">{{ userInitials }}</span>
        <span class="avatar-name">{{ userFirstName }}</span>
        <span class="avatar-chevron" aria-hidden="true">
          <i name="chevron-bottom" [size]="5" [color]="'var(--text-grey-color)'" Icons></i>
        </span>
      </button>
      @if (userMenuOpen) {
        <div class="user-dropdown" (click)="$event.stopPropagation()">
          <div class="user-dropdown-header">
            <span class="avatar-initials avatar-initials--lg" aria-hidden="true">{{ userInitials }}</span>
            <span class="user-dropdown-who">
              <span class="dropdown-name">{{ userName }}</span>
              @if (userSubName) { <span class="dropdown-email">{{ userSubName }}</span> }
              <span class="dropdown-email">{{ userEmail }}</span>
            </span>
          </div>
          <div class="user-dropdown-divider"></div>
          <button type="button" class="user-dropdown-item" (click)="openProfile()">
            <i name="user" [size]="18" [color]="'var(--text-color)'" Icons></i>
            <span>Mon profil</span>
          </button>
          <a routerLink="/admin/dashboard" class="user-dropdown-item" (click)="closeUserMenu()">
            <i name="home" [size]="18" [color]="'var(--text-color)'" Icons></i>
            <span>Tableau de bord</span>
          </a>
          <div class="user-dropdown-divider"></div>
          <button type="button" class="user-dropdown-item logout-item" (click)="onLogout(); closeUserMenu()">
            <span class="logout-arrow">→</span>
            <span>Déconnexion</span>
          </button>
        </div>
      }
    </div>
  </div>
</header>

@if (profileOpen) {
  <div class="profile-overlay" (click)="profileOpen = false">
    <form class="profile-dialog" (click)="$event.stopPropagation()" (ngSubmit)="saveProfile()">
      <h2 class="profile-dialog__title">Mon profil</h2>
      <label class="profile-field">Prénom / nom
        <input name="name" [(ngModel)]="profile.name" autocomplete="name" required />
      </label>
      <label class="profile-field">Sous-titre <span class="profile-field__hint">(facultatif, ex. votre fonction)</span>
        <input name="sub_name" [(ngModel)]="profile.sub_name" />
      </label>
      <p class="profile-dialog__email">{{ userEmail }}</p>
      @if (profileError) { <p class="profile-dialog__error">{{ profileError }}</p> }
      <div class="profile-dialog__actions">
        <button type="button" class="btn btn-secondary btn-sm" (click)="profileOpen = false">Annuler</button>
        <button type="submit" class="btn btn-primary btn-sm" [disabled]="profileSaving">{{ profileSaving ? 'Enregistrement…' : 'Enregistrer' }}</button>
      </div>
    </form>
  </div>
}
